// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ActivateWorkplaceUserData, ActivateWorkplaceUserErrors, ActivateWorkplaceUserResponses, BootstrapUserData, BootstrapUserErrors, BootstrapUserResponses, ClaimWorkplaceUserData, ClaimWorkplaceUserErrors, ClaimWorkplaceUserResponses, CreateWorkplaceUserData, CreateWorkplaceUserErrors, CreateWorkplaceUserResponses, DeactivateWorkplaceUserData, DeactivateWorkplaceUserErrors, DeactivateWorkplaceUserResponses, DeleteWorkplaceData, DeleteWorkplaceErrors, DeleteWorkplaceResponses, GetAndroidVersionData, GetAndroidVersionErrors, GetAndroidVersionResponses, GetCalendarWorkplaceUsersData, GetCalendarWorkplaceUsersErrors, GetCalendarWorkplaceUsersResponses, GetDeviceData, GetDeviceErrors, GetDeviceResponses, GetIosVersionData, GetIosVersionErrors, GetIosVersionResponses, GetMaintenanceData, GetMaintenanceErrors, GetMaintenanceResponses, GetWorkplaceData, GetWorkplaceErrors, GetWorkplaceResponses, GetWorkplaceUsersData, GetWorkplaceUsersErrors, GetWorkplaceUsersResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 利用に必要な Android アプリのバージョンを返します。
 */
export const getAndroidVersion = <ThrowOnError extends boolean = false>(options?: Options<GetAndroidVersionData, ThrowOnError>) => (options?.client ?? client).get<GetAndroidVersionResponses, GetAndroidVersionErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/api/apps/android/version',
    ...options
});

/**
 * 利用に必要な iOS アプリのバージョンを返します。
 */
export const getIosVersion = <ThrowOnError extends boolean = false>(options?: Options<GetIosVersionData, ThrowOnError>) => (options?.client ?? client).get<GetIosVersionResponses, GetIosVersionErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/api/apps/ios/version',
    ...options
});

/**
 * 認証済みアプリユーザーを初期化し、Firebase identity と紐づけます。
 */
export const bootstrapUser = <ThrowOnError extends boolean = false>(options: Options<BootstrapUserData, ThrowOnError>) => (options.client ?? client).post<BootstrapUserResponses, BootstrapUserErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/bootstrap-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 旧 device identifier に紐づくデバイス情報を返します。
 */
export const getDevice = <ThrowOnError extends boolean = false>(options?: Options<GetDeviceData, ThrowOnError>) => (options?.client ?? client).get<GetDeviceResponses, GetDeviceErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/devices',
    ...options
});

/**
 * 現在のメンテナンス状態を返します。
 */
export const getMaintenance = <ThrowOnError extends boolean = false>(options?: Options<GetMaintenanceData, ThrowOnError>) => (options?.client ?? client).get<GetMaintenanceResponses, GetMaintenanceErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/api/maintenance',
    ...options
});

/**
 * 勤務先ユーザーを有効化します。
 */
export const activateWorkplaceUser = <ThrowOnError extends boolean = false>(options: Options<ActivateWorkplaceUserData, ThrowOnError>) => (options.client ?? client).post<ActivateWorkplaceUserResponses, ActivateWorkplaceUserErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplace-users/{workplace_user_id}/activate',
    ...options
});

/**
 * 未紐づけの勤務先ユーザー行を現在の認証済みユーザーに紐づけます。
 */
export const claimWorkplaceUser = <ThrowOnError extends boolean = false>(options: Options<ClaimWorkplaceUserData, ThrowOnError>) => (options.client ?? client).post<ClaimWorkplaceUserResponses, ClaimWorkplaceUserErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplace-users/{workplace_user_id}/claim',
    ...options
});

/**
 * 勤務先ユーザーを無効化します。
 */
export const deactivateWorkplaceUser = <ThrowOnError extends boolean = false>(options: Options<DeactivateWorkplaceUserData, ThrowOnError>) => (options.client ?? client).post<DeactivateWorkplaceUserResponses, DeactivateWorkplaceUserErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplace-users/{workplace_user_id}/deactivate',
    ...options
});

/**
 * 勤務先を削除し、オーナーの追加可能ユーザー数を戻します。
 */
export const deleteWorkplace = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkplaceData, ThrowOnError>) => (options.client ?? client).delete<DeleteWorkplaceResponses, DeleteWorkplaceErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplaces/{workplace_id}',
    ...options
});

/**
 * 指定された ID の勤務先を返します。
 */
export const getWorkplace = <ThrowOnError extends boolean = false>(options: Options<GetWorkplaceData, ThrowOnError>) => (options.client ?? client).get<GetWorkplaceResponses, GetWorkplaceErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplaces/{workplace_id}',
    ...options
});

/**
 * 指定月のカレンダー表示に必要な勤務先ユーザーを返します。有効なユーザーに加えて、対象期間内にシフトがある無効化済みユーザーも含めます。
 */
export const getCalendarWorkplaceUsers = <ThrowOnError extends boolean = false>(options: Options<GetCalendarWorkplaceUsersData, ThrowOnError>) => (options.client ?? client).get<GetCalendarWorkplaceUsersResponses, GetCalendarWorkplaceUsersErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplaces/{workplace_id}/calendar-workplace-users',
    ...options
});

/**
 * 勤務先に所属するユーザー一覧を返します。
 */
export const getWorkplaceUsers = <ThrowOnError extends boolean = false>(options: Options<GetWorkplaceUsersData, ThrowOnError>) => (options.client ?? client).get<GetWorkplaceUsersResponses, GetWorkplaceUsersErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplaces/{workplace_id}/workplace_users',
    ...options
});

/**
 * まだユーザーに紐づいていない勤務先ユーザー招待行を作成します。
 */
export const createWorkplaceUser = <ThrowOnError extends boolean = false>(options: Options<CreateWorkplaceUserData, ThrowOnError>) => (options.client ?? client).post<CreateWorkplaceUserResponses, CreateWorkplaceUserErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/api/workplaces/{workplace_id}/workplace_users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
